module.exports = __webpack_public_path__ + "img/logo.1b8213b1.png";